import React from "react";
import { t } from "ttag";

export const DEFAULT_MESSAGE_LEVELS = {
    DEBUG: 10,
    INFO: 20,
    SUCCESS: 25,
    WARNING: 30,
    ERROR: 40,
};

export interface IMessage {
    level: number;
    message: string;
    tags: string;
    level_tag: string;
    extra_tags: string;
}

export interface IMessagesProps {
    messages: IMessage[];
}

export const getMessageByType = (extraTags: string, level: number) => {
    if (extraTags === "added-to-cart") {
        return <>{t`Added to Cart`}</>;
    }
    let message = "";
    switch (level) {
        case DEFAULT_MESSAGE_LEVELS.DEBUG:
            message = "Info";
            break;
        case DEFAULT_MESSAGE_LEVELS.INFO:
            message = "Info";
            break;
        case DEFAULT_MESSAGE_LEVELS.SUCCESS:
            message = "Success";
            break;
        case DEFAULT_MESSAGE_LEVELS.WARNING:
            message = "Warning";
            break;
        case DEFAULT_MESSAGE_LEVELS.ERROR:
            message = "Error";
            break;
        default:
            message = "Info";
            break;
    }
    return <>{t`${message}`}</>;
};

export const Messages: React.FC<IMessagesProps> = ({ messages }) => {
    return (
        <aside className="messages l-full-width">
            <ul className="messages__list">
                {messages.map((message: IMessage, i: number) => (
                    <li
                        className={`messages__item ${message.tags}`}
                        key={`key-${i}`}
                    >
                        <div className="messages__item__content l-capped-width">
                            <p>
                                <span
                                    className={`messages__item__category messages__item__category--${message.level_tag}`}
                                >
                                    {getMessageByType(
                                        message.extra_tags,
                                        message.level,
                                    )}
                                </span>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: message.message,
                                    }}
                                />
                            </p>
                            <button className="messages__item__close">
                                <svg
                                    className={`icon icon--reviews-no`}
                                    aria-label={`Close`}
                                    role="img"
                                >
                                    <use xlinkHref={`#reviews-no`} />
                                    <title>{`Close`}</title>
                                </svg>
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        </aside>
    );
};
